import { useEffect } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { Grid, makeStyles } from '@material-ui/core';
import { AdiccionesBreadcrumb } from '../components/AdiccionesBreadcrumb';
import { MENU_ADICCIONES, STEPPER_ADICCIONES } from '../data/constants';
import { cleanSolicitudesAdiccionesTomadas, getSolicitudesAdiccionesTomadasPorUsuario, setActiveStepAdicciones, setAfiliadoSeleccionadoAdicciones, setBreadcrumbCud } from '../../../actions/adicciones/adiccionesActions';
import { AdiccionesIngresoHome } from './ingreso/AdiccionesIngresoHome';
import { GestionAdiccionesHome } from './gestionAdicciones/GestionAdiccionesHome';
import { AdministrarSolicitudesAdicciones } from './components/AdministrarSolicitudesAdicciones';

const useStyles = makeStyles((theme) => ({
  root: {
    flexGrow: 1,
  },
}));

export const HomeAdicciones = (props) => {
  const dispatch = useDispatch();
  const classes = useStyles();

  const { activeBreadcrumb, solicitudSeleccionada, solicitudesTomadasUsuario } = useSelector((state) => state.adicciones);
  const { permisos: permisosUser } = useSelector((state) => state.auth);

  useEffect(() => {
    if (props.location.state?.from === "/adicciones/gestion" && solicitudSeleccionada) {
      dispatch(setBreadcrumbCud(MENU_ADICCIONES.INGRESO_SOLICITUD));
      dispatch(setActiveStepAdicciones(STEPPER_ADICCIONES.DETALLES_ORDEN));
      dispatch(setAfiliadoSeleccionadoAdicciones(solicitudSeleccionada?.afiliado));

    } else {
      dispatch(cleanSolicitudesAdiccionesTomadas());
      dispatch(getSolicitudesAdiccionesTomadasPorUsuario());
      dispatch(setBreadcrumbCud(MENU_ADICCIONES.DESELECCIONAR));
    }
  }, [props.location.state?.from, dispatch]);

  return (
    <div className={classes.root} >
      <Grid
        container
        spacing={1}
        direction="row"
        justify="center"
        alignItems="center"
      >
        <Grid item xs={12} styles={{ padding: 5 }}>
          <AdiccionesBreadcrumb permisosUser={permisosUser} />
        </Grid>
        {!activeBreadcrumb && solicitudesTomadasUsuario.length > 0 &&
          <AdministrarSolicitudesAdicciones
            type={'currentUser'}
          />
        }
        {activeBreadcrumb === MENU_ADICCIONES.INGRESO_SOLICITUD && (
          <AdiccionesIngresoHome
            fromGestion={props.location.state?.from === "/adicciones/gestion"}
          />
        )}
        {activeBreadcrumb === MENU_ADICCIONES.GESTION_SOLICITUD && (
          <GestionAdiccionesHome />
        )}
      </Grid>
    </div>
  );
}
